import { request } from '@/common/services/request';

export const queryStoreProfitReport = ({ endDate, organizationId, scope, startDate }) =>
  request('/api/operations/tenant/fact-report', {
    data: { endDate, scope, startDate },
    method: 'POST',
    params: { organizationId },
  });

export const queryStoreProfitReportCalculationNode = ({
  current,
  drilldownPath,
  endDate,
  organizationId,
  pageSize,
  rootMetricId,
  scope,
  startDate,
}) =>
  request('/api/operations/tenant/fact-report/calculation-node', {
    data: { current, drilldownPath, endDate, pageSize, rootMetricId, scope, startDate },
    method: 'POST',
    params: { organizationId },
  });
